export function RequiredAsterisk() {
  return <strong className="text-brand-primary">*</strong>;
}
